import { createRoot } from "react-dom/client";
import { ConvexProvider } from "convex/react";
import { convex } from "./lib/convexClient";
import App from "./App.tsx";
import { SpeedInsights } from "@vercel/speed-insights/react";
import { initAnalytics } from "./lib/analytics";
import "./i18n/config";
import "@fontsource-variable/cormorant-garamond";
import "@fontsource-variable/jost";
import "./index.css";

// Load GA immediately if the user already consented in a previous session
initAnalytics();

createRoot(document.getElementById("root")!).render(
  <ConvexProvider client={convex}>
    <App />
    <SpeedInsights />
  </ConvexProvider>
);
